import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import { IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';
import { jsonRegionIdToTransportType } from 'shared/utils/adfox/jsonRegionIdToTransportType';

import { TJsonQuery } from '../../../../../../../../../packages/JsonQuery';
import { TgbNativedescGeneralProps } from '../../TgbNativedescGeneral';

type TGetTgbNativedescGeneralPropsOptions = {
  bannerEnrichments: IBannerEnrichments | undefined;
  context: TTgbNativedescGeneralContext;
  sizes: TAdFoxBannerCompleteSizes;
  jsonQuery: TJsonQuery;
};

export function getTgbNativedescGeneralProps({
  sizes,
  jsonQuery,
  bannerEnrichments,
  context: {
    annotation,
    image,
    url,
    metroDistance,
    metroColor,
    metro,
    description,
    title,
    location,
    button,
    label,
    logoImageUrl,
    builderName,
    mortgageTermsWarning,
    mortgageWarning,
  },
}: TGetTgbNativedescGeneralPropsOptions): TgbNativedescGeneralProps {
  const tgbNativedescGeneralProps: TgbNativedescGeneralProps = {
    logoImageUrl,
    url,
    transports: [],
    label,
    button,
    image,
    annotation,
    builderName,
    title,
    address: location,
    description,
    sizes,
    mortgageTermsWarning,
    mortgageWarning,
  };

  if (metro) {
    const iconType = jsonRegionIdToTransportType(jsonQuery);

    tgbNativedescGeneralProps.transports.push({
      iconColor: metroColor,
      iconType,
      id: 1,
      name: metro,
      remoteness: metroDistance,
    });
  }

  if (bannerEnrichments) {
    Object.assign<TgbNativedescGeneralProps, Partial<TgbNativedescGeneralProps>>(tgbNativedescGeneralProps, {
      address: bannerEnrichments.address,
      builderName: bannerEnrichments.publisher.name,
      logoImageUrl: bannerEnrichments.publisher.logo.url,
      transports: bannerEnrichments.transports,
    });
  }

  return tgbNativedescGeneralProps;
}
